import { Button } from "@/components/ui/button";
import { UsersIcon } from "@/lib/icons";
import { cn } from "@/lib/utils";
import { useTaskFilterStore } from "@/stores/useTaskFilterStore";

/** Board toolbar toggle that shows or hides other people's Muistilistat (hidden by default). */
export function MemoListToggle({ className }: { className?: string }) {
  const { showOthersMemoLists, setShowOthersMemoLists } = useTaskFilterStore();
  const label = showOthersMemoLists
    ? "Piilota muiden muistilistat"
    : "Näytä muiden muistilistat";

  return (
    <Button
      variant={showOthersMemoLists ? "default" : "outline"}
      size="icon"
      onClick={() => setShowOthersMemoLists(!showOthersMemoLists)}
      aria-pressed={showOthersMemoLists}
      aria-label={label}
      title={label}
      className={cn("shrink-0", className)}
    >
      <UsersIcon className="h-4 w-4" />
    </Button>
  );
}
